import { CardHeader } from '@beunity/design';
import { requirePhoneConfirmation } from 'src/lib/require_phone_confirmation';

CardHeader.prototype.requirePhoneConfirmation = requirePhoneConfirmation;

export default CardHeader;

// Hack for Rails preview:
// customElements.get('bu-card-header') || customElements.define('bu-card-header', CardHeader);
